"use strict";
// @ts-ignore
try {
    self['workbox:core:6.6.1'] && _();
}
catch (e) { }
